import { Tag } from 'antd'
import { FC } from 'react'
import Task, { TaskStatuses } from '../../../../../types/api/task'

interface TaskStatusCellProps {
    taskStatus?: Task['taskStatus']
}

const taskStatusColor: Partial<Record<TaskStatuses, string>> = {
    Новая: 'default',
    'В работе': 'blue',
    Завершена: 'green',
    Отменена: 'red',
}

const TaskStatusCell: FC<TaskStatusCellProps> = ({ taskStatus }) => {
    if (!taskStatus) return null

    const color = taskStatusColor[taskStatus as TaskStatuses] ?? 'default'

    return <Tag color={color} style={{ margin: 0 }}>{taskStatus}</Tag>
}

export default TaskStatusCell

